/**
 * Extracts the ID from a given URL, using the hash part of the URL.
 * The ID is expected to be the part after the hash symbol (#).
 * If the hash is not present or does not contain an ID, an empty string is returned.
 *
 * @param path - The path from which to extract the ID.
 * @returns The extracted ID or an empty string if not found.
 */
export function getIdFromPath(path: string): string {
	const url = new URL(path, "http://example.com");
	return url.hash.replace("#", "");
}
